import styled, { injectGlobal } from 'styled-components';

injectGlobal`
  #main.lp{
    height: 100%;
    display: flex;
    flex-direction: column;
  }
`;
export const Header = styled.header`
  background-color: #000;
  text-align: center;
  padding: 10px;
  max-height: 50px;
  flex: 1;
  img {
    width: 140px;
    height: auto;
  }
`;

export const Footer = styled.p`
  flex: 1;
  max-height: 40px;
  text-align: center;
  font-size: 12px;
  color: #fff;
  margin: 0;
  background-color: #000;
  padding: 10px;
`;



// WEBPACK FOOTER //
// ./src/assets/styles/lp.js